import { useAppDataStore } from '@stores/useAppDataStore';
import { useAuthStore } from '@stores/useAuthStore';
import { URL_USER_NOTIFICATIONS_POLL } from '@tools/routes/routes';
import { eventBus } from '@tools/event-bus';

export const updateNotifications = () => {
  const menuDisabled = document.querySelector('.header--mobile--disabled');
  if (menuDisabled && window.BREAKPOINTS.isMobile) {
    return;
  }

  const pollingInterval = 300000; // ms (equals to 5 minutes)
  const stripOldNotifRegexp = /\(\d*?\)/;
  const oldTitle = window.document.title.replace(stripOldNotifRegexp, '');

  let oldCounterTotalValue = 0;
  let oldCounterMessageValue = 0;

  const menuSelector = document.querySelector('.menu-auth');
  if (menuSelector && menuSelector.dataset) {
    oldCounterTotalValue = parseInt(menuSelector.dataset.total, 10) || 0;
    oldCounterMessageValue = (parseInt(menuSelector.dataset.messages, 10) || 0)
      + (parseInt(menuSelector.dataset.proposal, 10) || 0);
  }

  // Update document title value when counter change
  eventBus.addEventListener('notifications-counter-change', (newCounterValue) => {
    if (newCounterValue) {
      const elementPinNotification = document.getElementById('pin-notification-mobile');
      const newPinNotification = newCounterValue.unread_messages + newCounterValue.unread_match_proposal;
      if (newPinNotification === 0) {
        window.document.title = oldTitle;
        elementPinNotification.innerHTML = '';
      }
      oldCounterMessageValue = newPinNotification;
    }
  });

  /**
   * Fetch notification counter by polling
   */
  function pollNotifications() {
    const url = `${URL_USER_NOTIFICATIONS_POLL}?timestamp=${Date.now()}`;
    let emitNotificationCounterChange = false;

    fetch(url)
      .then((response) => response.json())
      .then((responseNotifications) => {
        if (responseNotifications.unread_total !== undefined
          && responseNotifications.unread_total !== oldCounterTotalValue) {
          oldCounterTotalValue = responseNotifications.unread_total;
          emitNotificationCounterChange = true;
        }

        if (responseNotifications.unread_messages !== undefined
          && responseNotifications.unread_messages !== oldCounterMessageValue
          && responseNotifications.unread_match_proposal !== undefined
          && responseNotifications.unread_match_proposal
        ) {
          oldCounterMessageValue = responseNotifications.unread_messages
            + responseNotifications.unread_match_proposal;
          emitNotificationCounterChange = true;
        }

        if (emitNotificationCounterChange === true) {
          eventBus.dispatchEvent(
            new CustomEvent('notifications-counter-change', {
              detail: responseNotifications,
            }),
          );
        }
      });
  }

  // Fetch notification counter on interval
  if (useAuthStore().isLoggedIn) {
    window.setInterval(() => {
      pollNotifications();
    }, pollingInterval);
  }

  // Display color pin on burger menu if notifications
  const notifications = useAppDataStore().userNotifications;
  const burger = document.querySelector('.header__burger');
  if (burger) {
    if (notifications) {
      burger.classList.add('active');
      return;
    }

    burger.classList.remove('active');
  }
};
